import React from 'react';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="grid-pattern"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Human like brain for
            <span className="gradient-text"> your enterprise</span>
          </h1>
          
          <p className="hero-subtitle">
            CerebralMachines is a human-like brain for your enterprise. 
            Uniting ontologies, business rules, and statistical models to 
            execute both deterministic and undeterministic computing, 
            with continuous learning to build superior context, and act 
            with precision. Level 5 Automated AI solutions are possible now.
          </p>

          <div className="hero-actions">
            <a href="/signup">
              <button className="btn-primary btn-large">
                Get a Demo
              </button>
            </a>
            <a href="#platform">
              <button className="btn-outline btn-large">
                See Architecture
              </button>
            </a>
          </div>
        </div>

        <div className="hero-dashboard">
          <div className="dashboard-card">
            <div className="dashboard-header">
              <h3>CerebralMachines Dashboard</h3>
              <div className="status-indicator">
                <span className="pulse"></span>
                <span>Live</span>
              </div>
            </div>
            
            <div className="dashboard-stats">
              <div className="stat-item">
                <div className="stat-value gradient-text">2,342</div>
                <div className="stat-label">Active Nodes</div>
              </div>
              <div className="stat-item">
                <div className="stat-value gradient-text">1,441</div>
                <div className="stat-label">Processed Events</div>
              </div>
              <div className="stat-item">
                <div className="stat-value gradient-text">98.7%</div>
                <div className="stat-label">Accuracy Rate</div>
              </div>
            </div>

            <div className="dashboard-visualization">
              <div className="node-network">
                <div className="network-node node-1"></div>
                <div className="network-node node-2"></div>
                <div className="network-node node-3"></div>
                <div className="network-node node-4"></div>
                <div className="connection conn-1"></div>
                <div className="connection conn-2"></div>
                <div className="connection conn-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

